import { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { names } from 'Constants';
import { useResponsive } from 'Hooks';
import { clx } from 'Utils';
import { Card, DecorationTab } from 'Elements';
import styles from 'partials/decoration/page-decoration-box.module.scss';

export const SkeletonPartnerDecorationBox: FC = () => {
	const { partners } = names;
	const { partner_id } = useParams();
	const { pathname } = useLocation();
	const { isTabletAndAbove, isDesktopAndAbove } = useResponsive();

	const getImageSize = () => {
		return isDesktopAndAbove ? 160 : isTabletAndAbove ? 136 : 112;
	};

	const defaultTab =
		pathname === `${partners.path}/${partner_id}` ||
		pathname === `${partners.path}/${partner_id}/general`;

	const tabs = [
		{
			id: 0,
			title: 'tab.general',
			path: 'general',
			isActive: defaultTab
		},
		{
			id: 1,
			title: 'tab.jobs',
			path: 'jobs',
			isActive: pathname === `${partners.path}/${partner_id}/jobs`
		}
	];

	const skeletonStyle: React.CSSProperties = {
		minHeight: '1.5em',
		width: '100%'
	};

	return (
		<Card tab className="mb-4">
			<div className="d-flex justify-content-between align-items-start">
				<div
					className={clx(
						styles.body,
						'd-flex flex-column flex-md-row gap-3'
					)}>
					<div tabIndex={-1} className={styles.logo}>
						<div className={styles.logoBox}>
							<div
								className="skeletonStyle"
								style={{
									width: getImageSize(),
									height: getImageSize()
								}}
							/>
						</div>
					</div>
					<div className="flex-grow-1">
						<div
							className="skeletonStyle"
							style={{
								width: '60%',
								height: 24,
								marginBottom: 8
							}}
						/>
						<div className="d-flex align-items-center flex-wrap gap-3 mb-3">
							<div
								className="skeletonStyle"
								style={{
									width: 100,
									height: 20
								}}
							/>
						</div>
					</div>
				</div>
				<div>
					<div
						className="skeletonStyle"
						style={{
							...skeletonStyle,
							height: '3.5em',
							width: '12em'
						}}
					/>
				</div>
			</div>
			<DecorationTab tabs={tabs} />
		</Card>
	);
};
